export const emailBatchesKeys = {
  all: () => ['email-batches'] as const,
  list: () => [...emailBatchesKeys.all(), 'list'] as const,
};
